import { extend_timed_array } from 'console/redux/data-utils';
import { openProPopup } from 'console/account/redux/action';
import { getTariffProName } from 'console/billing/account-tariff/utils';
import { selectNeedOpenAdvertisementPopup } from 'console/billing/billing-utils';
import { getAPIErrorMessage } from 'api';
import { normalize_time } from './sources/common';
import { LoadDataType, ThermostatWorkVarName, } from './load-types';
import { array_uniq } from 'utils';
import { openSnakeError } from 'console/dialogs/error/snake-error/redux/actions';
export class GraphDataLoader {
    _mintime;
    _maxtime;
    _data;
    async load(mintime, maxtime) {
        [this._mintime, this._maxtime, this._data] = [mintime, maxtime, {}];
        this._data = await this._do_load(mintime, maxtime);
        return this._data;
    }
    async _do_load(mintime, maxtime) {
        return new Promise(() => { });
    }
    data() {
        return this._data;
    }
    bind_updates(callback) { }
    unbind_updates() { }
    _extend_time_array(array, new_values) {
        return extend_timed_array(array, new_values, this._mintime, this._maxtime, 0);
    }
}
export class LoaderProvider {
    get_loader(data_key) { }
}
export class LoadDataCombiner {
    api;
    ui;
    _requests;
    _immediate_call;
    constructor(api, ui) {
        this.api = api;
        this.ui = ui;
        this._requests = [];
        this._immediate_call = null;
    }
    async request(device_id, data_types, mintime, maxtime, options) {
        for (const request of this._requests) {
            if (request.device_id === device_id &&
                request.mintime === mintime &&
                request.maxtime === maxtime) {
                request.data_types.push(...data_types);
                if (options != null) {
                    request.options = { ...request.options, ...options };
                }
                return request.promise;
            }
        }
        const request = {
            device_id,
            mintime,
            maxtime,
            data_types: data_types.slice(),
            options,
            resolve: () => { },
            reject: () => { },
            promise: new Promise(() => { }),
        };
        request.promise = new Promise((resolve, reject) => {
            request.resolve = resolve;
            request.reject = reject;
        });
        this._requests.push(request);
        // Это важное место! Тут собираем все данные от всех типов, чтобы на сервер сделать 1 запрос вместо 25
        if (this._immediate_call == null) {
            this._immediate_call = window.setImmediate(() => this._send_requests());
        }
        return request.promise;
    }
    async _send_requests() {
        let requests;
        [requests, this._requests, this._immediate_call] = [this._requests, [], null];
        try {
            const json = await this.api.load_data(requests.map(({ data_types, mintime, maxtime, options, device_id }) => ({
                data_types: array_uniq(data_types),
                mintime,
                maxtime,
                options,
                device_id,
            })));
            // const json = await postJob(
            //     {
            //         type: JobType.zont_graph,
            //         requests: requests.map(
            //             ({promise, resolve, reject, ...rest}) => rest
            //         ) as DataRequestItem[],
            //     },
            //     (error) => {
            //         throw error;
            //     },
            //     this.api
            // );
            for (let i = 0; i < requests.length; i++) {
                requests[i].resolve(json.responses[i]);
            }
            //Проверяем, нужно ли показывать плашку про историю тарифа ПРОФИ
            //Временно отключено для андроида
            if (selectNeedOpenAdvertisementPopup(this.ui.store.getState(), json.responses.some((resp) => resp?.time_truncated))) {
                this.ui.store.dispatch(openProPopup(`2 годичная история доступна в тарифе ${getTariffProName()}!`));
            }
            // return json.responses;
        }
        catch (error) {
            const err_msg = getAPIErrorMessage(error, 'Не удалось загрузить данные');
            const result_error = `Не удалось загрузить данные для графиков: ${err_msg}`;
            for (const req of requests) {
                req.reject(result_error);
            }
            this.ui.store.dispatch(openSnakeError(result_error));
        }
    }
}
export class CombinedDataLoader extends GraphDataLoader {
    device;
    data_types;
    combiner;
    constructor(device, data_types, combiner) {
        //@ts-ignore
        super(...arguments);
        this.device = device;
        this.data_types = data_types;
        this.combiner = combiner;
    }
    options() { }
    //@ts-ignore
    async _do_load(mintime, maxtime) {
        return this.combiner.request(this.device.id(), this.data_types, mintime, maxtime, this.options());
    }
}
export class SingleDataLoader extends CombinedDataLoader {
    data_type;
    _binding;
    _last_connect_time_binding;
    constructor(device, data_type, combiner) {
        super(device, [data_type], combiner);
        this.data_type = data_type;
    }
    async _do_load(mintime, maxtime) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        const result = super._do_load(...arguments).then((response) => {
            //@ts-ignore
            return response[this.data_type];
        });
        return result;
    }
    bind_updates(callback) {
        this._binding = this.device.bind('new_data', (event) => {
            if (!event)
                return;
            if (!(this.data_type in event)) {
                return;
            }
            if (this._data == null) {
                return;
            }
            this._handle_loader_update(event);
            callback(this._mintime, this._maxtime, this._data);
        });
    }
    unbind_updates() {
        this._binding?.unbind();
    }
    _handle_loader_update(event) {
        const event_d = event[this.data_type];
        const item = this._data;
        this._data = this._extend_time_array(item, event_d);
    }
}
export class WeatherDataLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.weather, combiner);
    }
    options() {
        return { weather: { include_last_before: true } };
    }
}
export class TemperatureLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.temperature, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        for (const [therm_id, therm_data] of Object.entries(d ?? {})) {
            const item = this._data;
            if (item[therm_id] == null) {
                item[therm_id] = {};
                this._data = item;
            }
            const params_item = item[therm_id];
            params_item.temperature = this._extend_time_array(params_item.temperature, therm_data.temperature);
            this._data = item;
        }
    }
}
export class ThermostatWorkLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.thermostat_work, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const simple_fields = [
            ThermostatWorkVarName.boiler_work_time,
            ThermostatWorkVarName.thermostat_mode,
            ThermostatWorkVarName.target_temp,
            ThermostatWorkVarName.power,
            ThermostatWorkVarName.fail,
            ThermostatWorkVarName.gate,
            ThermostatWorkVarName.dhw_t,
            ThermostatWorkVarName.pza_t,
        ];
        for (const data_name of simple_fields) {
            const item = this._data;
            let params_item = item[data_name];
            params_item = this._extend_time_array(params_item, d[data_name]);
            this._data = item;
        }
        const event_d = event[this.data_type];
        const item = this._data;
        if (item.ot == null)
            item.ot = {};
        for (const [ot_name, ot_values] of Object.entries(event_d.ot ?? {})) {
            //@ts-ignore
            item.ot[ot_name] = this._extend_time_array(item.ot[ot_name], ot_values);
        }
        if (item.zones == null)
            item.zones = {};
        for (const [zone_id, zone_data] of Object.entries(event_d.zones ?? {})) {
            if (item.zones[zone_id] == null)
                item.zones[zone_id] = {};
            item.zones[zone_id].target_temp = this._extend_time_array(item.zones[zone_id].target_temp, zone_data.target_temp);
            item.zones[zone_id].worktime = this._extend_time_array(item.zones[zone_id].worktime, zone_data.worktime);
        }
        this._data = item;
    }
}
export class HeatSetTempLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.heatsettemp, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const item = this._data;
        for (const [zone_no, zone_data] of Object.entries(d ?? {})) {
            const zone_id = zone_no;
            item[zone_id] = this._extend_time_array(item[zone_id], zone_data);
        }
        this._data = item;
    }
}
export class ZTCStateLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.ztc_state, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const item = this._data;
        item.gsm_level = this._extend_time_array(item.gsm_level, d.gsm_level);
        item.gsm_state = this._extend_time_array(item.gsm_state, d.gsm_state);
        item.gsm_balance = this._extend_time_array(item.gsm_balance, d.gsm_balance);
        item.voltage = this._extend_time_array(item.voltage, d.voltage);
        item.status_flags = this._extend_time_array(item.status_flags, d.status_flags);
        item.wifi_rssi = this._extend_time_array(item.wifi_rssi ?? [], d.wifi_rssi ?? []);
        if (item.temperature == null) {
            item.temperature = [];
        }
        if (d.temperature)
            for (let i = 0; i < d.temperature.length; i++)
                item.temperature[i] = this._extend_time_array(item.temperature[i], d.temperature[i]);
        this._data = item;
    }
}
export class RFLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.rf, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const item = this._data;
        for (const [serial, data] of Object.entries(d ?? {}))
            item[serial] = this._extend_time_array(item[serial], data);
        this._data = item;
    }
}
export class GTWReportLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.gtw_report, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const item = this._data;
        for (const [key, values] of Object.entries(d ?? {})) {
            const index = key;
            item[index] = this._extend_time_array(item[index], values);
        }
        this._data = item;
    }
}
export class OTZonesLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.otzones, combiner);
    }
    _handle_loader_update(event) {
        const d = event[this.data_type];
        const item = this._data;
        for (const [zone_id, ot_data] of Object.entries(d ?? {})) {
            if (item[zone_id] == null) {
                //@ts-ignore
                item[zone_id] = {};
            }
            const params_item = item[zone_id];
            for (const [ot_field, new_items] of Object.entries(ot_data ?? {})) {
                //@ts-ignore
                params_item[ot_field] = this._extend_time_array(
                //@ts-ignore
                params_item[ot_field], new_items);
            }
        }
        this._data = item;
    }
}
export class CustomControlsLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.custom_controls, combiner);
    }
    load(mintime, maxtime) {
        //@ts-ignore
        return super.load(...arguments).then((data) => {
            // @ts-ignore
            const last_connect_time = this.device.last_connect_time()?.getTime();
            if (data.length > 0 && last_connect_time != null) {
                const lct_unix = ~~(last_connect_time / 1e3);
                const [last_time, last_value] = data[data.length - 1];
                if (last_time < lct_unix)
                    data.push([Math.min(lct_unix, maxtime), last_value]);
            }
            return data;
        });
    }
    bind_updates(callback) {
        //@ts-ignore
        super.bind_updates(...arguments);
        this._last_connect_time_binding = this.device.bind('last_connect_time', () => {
            const item = this._data;
            if (!(item?.length > 0))
                return;
            // @ts-ignore
            const last_connect_time = this.device.last_connect_time()?.getTime();
            if (last_connect_time != null) {
                const lct_unix = ~~(last_connect_time / 1e3);
                if (this._mintime <= lct_unix && lct_unix <= this._maxtime) {
                    const [_last_time, last_value] = item[item.length - 1];
                    item.push([lct_unix, last_value]);
                    callback(this._mintime, this._maxtime, this._data);
                }
            }
            this._data = item;
        });
    }
    unbind_updates() {
        //@ts-ignore
        super.unbind_updates(...arguments);
        this._last_connect_time_binding?.unbind();
    }
}
export class Z3KWebElementsStateLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.z3k_web_element, combiner);
    }
    async _do_load(mintime, maxtime) {
        let all_objects_data = 
        //@ts-ignore
        await super._do_load(...arguments);
        // @ts-ignore
        const last_connect_time = this.device.last_connect_time()?.getTime();
        if (last_connect_time != null) {
            for (const [object_id, { state }] of Object.entries(all_objects_data ?? {})) {
                const normalized = normalize_time(state, 0);
                if (state.length > 0) {
                    const lct_unix = parseInt((last_connect_time / 1e3).toString());
                    const [last_time, last_value] = normalized[normalized.length - 1];
                    // data.push [Math.min(lct_unix, maxtime), last_value]
                    const fake_time = Math.min(lct_unix, maxtime);
                    if (fake_time > last_time)
                        all_objects_data = {
                            ...all_objects_data,
                            [object_id]: {
                                state: [...normalized, [fake_time, last_value]],
                            },
                        };
                }
            }
        }
        return all_objects_data;
    }
    _handle_loader_update(event) {
        const item = this._data;
        const d = event[this.data_type];
        for (const [object_id, object_data] of Object.entries(d ?? {})) {
            const index = object_id;
            item[index].state = this._extend_time_array(item[index].state, object_data.state);
        }
        this._data = item;
    }
    bind_updates(callback) {
        //@ts-ignore
        super.bind_updates(...arguments);
        this._last_connect_time_binding = this.device.bind('last_connect_time', () => {
            // @ts-ignore
            const last_connect_time = this.device.last_connect_time()?.getTime();
            if (last_connect_time != null) {
                for (const [object_id, { state }] of Object.entries(this._data ?? {})) {
                    if (state.length > 0) {
                        const lct_unix = last_connect_time / 1e3;
                        if (this._mintime <= lct_unix && lct_unix <= this._maxtime) {
                            const [_last_time, last_value] = state[state.length - 1];
                            const item = this._data;
                            if (_last_time < lct_unix) {
                                const index = object_id;
                                item[index].state.push([lct_unix, last_value]);
                            }
                            this._data = item;
                        }
                    }
                }
            }
            callback(this._mintime, this._maxtime, this._data);
        });
    }
    unbind_updates() {
        //@ts-ignore
        super.unbind_updates(...arguments);
        this._last_connect_time_binding?.unbind();
    }
}
export class Z3KTemperatureLoader extends SingleDataLoader {
    constructor(device, combiner) {
        super(device, LoadDataType.z3k_temperature, combiner);
    }
    _handle_loader_update(event) {
        const item = this._data;
        const d = event[this.data_type];
        // console.log('Z3KTemperatureLoader _handle_loader_update', d, item, this._data);
        for (const [object_id, object_data] of Object.entries(d ?? {})) {
            const index = object_id;
            item[index] = this._extend_time_array(item[index], object_data);
        }
        this._data = item;
    }
}
export class Z3KCommonLoader extends SingleDataLoader {
    _handle_loader_update(event) {
        const d = event[this.data_type];
        for (const [object_id, object_data] of Object.entries(d ?? {})) {
            let item = this._data;
            //@ts-ignore
            let new_object_data = item[object_id] ?? {};
            for (const [name, array] of Object.entries(object_data ?? {}))
                new_object_data = {
                    ...new_object_data,
                    [name]: this._extend_time_array(new_object_data[name], array),
                };
            item = { ...item, [object_id]: new_object_data };
            this._data = item;
        }
    }
}
export class APILoaderProvider extends LoaderProvider {
    ui;
    device;
    combiner;
    constructor(ui, api, device) {
        //@ts-ignore
        super(...arguments);
        this.ui = ui;
        this.device = device;
        this.combiner = new LoadDataCombiner(api, ui);
    }
    // get_loader(data_key: LoadDataType) {
    get_loader(data_key) {
        switch (data_key) {
            case LoadDataType.ztc_state:
                return new ZTCStateLoader(this.device, this.combiner);
            case LoadDataType.temperature:
                return new TemperatureLoader(this.device, this.combiner);
            case LoadDataType.thermostat_work:
                return new ThermostatWorkLoader(this.device, this.combiner);
            case LoadDataType.heatsettemp:
                return new HeatSetTempLoader(this.device, this.combiner);
            case LoadDataType.rf:
                return new RFLoader(this.device, this.combiner);
            case LoadDataType.gtw_report:
                return new GTWReportLoader(this.device, this.combiner);
            case LoadDataType.custom_controls:
                return new CustomControlsLoader(this.device, this.combiner);
            case LoadDataType.gps:
                return new SingleDataLoader(this.device, data_key, this.combiner);
            case LoadDataType.weather:
                return new WeatherDataLoader(this.device, this.combiner);
            case LoadDataType.otzones:
                return new OTZonesLoader(this.device, this.combiner);
            case LoadDataType.z3k_temperature:
                return new Z3KTemperatureLoader(this.device, this.combiner);
            case LoadDataType.z3k_boiler_adapter:
                return new Z3KCommonLoader(this.device, LoadDataType.z3k_boiler_adapter, this.combiner);
            case LoadDataType.z3k_radio_sensor:
                return new Z3KCommonLoader(this.device, LoadDataType.z3k_radio_sensor, this.combiner);
            case LoadDataType.z3k_heating_circuit:
                return new Z3KCommonLoader(this.device, LoadDataType.z3k_heating_circuit, this.combiner);
            case LoadDataType.z3k_analog_input:
                return new Z3KCommonLoader(this.device, LoadDataType.z3k_analog_input, this.combiner);
            case LoadDataType.z3k_web_element:
                return new Z3KWebElementsStateLoader(this.device, this.combiner);
            default:
                throw new Error(`Unknown graph data loader key: ${data_key}`);
        }
    }
}
